module.exports = __webpack_public_path__ + "img/htg.df6f5762.png";